import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const DELETE_SUFFIX = "/inspections/requested-inspections";

const RequestedInspectionsTable = () => (
  <LmsTable
    skipClick
    deleteSuffix={DELETE_SUFFIX}
    apiSuffix="/inspections/lms-requested-inspections"
    actionButtons={["add", "edit", "remove", "export"]}
    sortable={["Schedule Date"]}
    columnLabelsDictionary={{ borrowerOrganization: "Borrower" }}
  />
);

const RequestedInspectionsForm = ({ id }) => {
  const drawScheduleEndpoint = id ? `/draws/auto-draw-schedule/${id}` : "";
  const [{ data = { isActive: true }, isLoading, error }] = useFetchData(
    drawScheduleEndpoint
  );

  const myForm = new BCFormController(data, {
    deleteSuffix: DELETE_SUFFIX,
    submitSuffix: "/inspections/requested-inspections",
    clearSuffixesOnSubmit: [drawScheduleEndpoint],
  });

  myForm.addCenteredGroup([
    myForm.getInputField("Name", { required: true }),
    myForm.getCheckboxField("Is Active"),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Auto Draw", "/metadata/list-auto-draws", {
      name: "autoDrawId",
      required: true,
    }),
    myForm.getCalendarField("Schedule Date", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Recurrence", "/metadata/list-recurrences", {
      name: "recurrenceId",
    }),
    myForm.getInputField("Frequency Description"),
  ]);

  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);

  return (
    <LmsFormGenerator
      error={error}
      myForm={myForm}
      isLoading={isLoading}
      actions={
        id
          ? ["save", "save-close", "delete", "close"]
          : ["save-new", "save-continue", "save-close", "close"]
      }
    />
  );
};

const LmsServicingRequestedInspections = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params, [
    "add",
    "edit",
  ]);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <RequestedInspectionsTable />}
      {(isAdd || isEdit) && <RequestedInspectionsForm id={id} />}
    </>
  );
};

export default LmsServicingRequestedInspections;
